import InitialTabs from '@/components/organisms/Tabs/Tabs';
import styled from '@emotion/styled';

export const Tabs = styled(InitialTabs)`
    display: flex;
    background-color: ${({ theme }) => theme.color.white100};
`;
